import { useEffect, useState, useCallback } from "react";
import axios from "axios";
import { API } from "@/config";

let _cache = null;
let _promise = null;
const _listeners = new Set();

const FALLBACK = [
  { key: "cariste", label: "Cariste", order: 1 },
  { key: "chef_equipe", label: "Chef d'équipe", order: 2 },
  { key: "preparation_commandes", label: "Préparation de commandes", order: 3 },
  { key: "manutentionnaire", label: "Manutentionnaire", order: 4 },
  { key: "administratif", label: "Administratif", order: 5 },
  { key: "encadrement", label: "Encadrement", order: 6 },
];

async function fetchPrefs() {
  if (_cache) return _cache;
  if (_promise) return _promise;
  _promise = axios.get(`${API}/job-preferences`)
    .then((r) => { _cache = r.data || []; _promise = null; return _cache; })
    .catch(() => { _cache = FALLBACK; _promise = null; return _cache; });
  return _promise;
}

export function invalidateJobPreferencesCache(newList) {
  _cache = Array.isArray(newList) ? newList : null;
  _listeners.forEach((cb) => { try { cb(_cache); } catch { /* ignore */ } });
}

/**
 * Returns { prefs, loading } where prefs is an array of {key, label}
 */
export function useJobPreferences() {
  const [prefs, setPrefs] = useState(_cache || []);
  const [loading, setLoading] = useState(!_cache);

  useEffect(() => {
    let mounted = true;
    fetchPrefs().then((list) => {
      if (mounted) { setPrefs(list); setLoading(false); }
    });
    const cb = (list) => { if (mounted && list) setPrefs(list); };
    _listeners.add(cb);
    return () => { mounted = false; _listeners.delete(cb); };
  }, []);

  const reload = useCallback(async () => {
    _cache = null;
    const list = await fetchPrefs();
    invalidateJobPreferencesCache(list);
    return list;
  }, []);

  return { prefs, loading, reload };
}
